import { render, staticRenderFns } from "./PoqLinkModal.vue?vue&type=template&id=053ff566&"
import script from "./PoqLinkModal.vue?vue&type=script&lang=ts&"
export * from "./PoqLinkModal.vue?vue&type=script&lang=ts&"
import style0 from "./PoqLinkModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports